import React, { useContext, useRef } from 'react';
import {
  AgentLayout as Layout,
  AgentProfileDocument,
  Banner,
  DeleteModal,
  FileUpload,
  ProfileImage
} from '../../components/Portal';
import {
  AppBar,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography
} from '@material-ui/core';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import DeleteRounded from '@material-ui/icons/DeleteRounded';
import { privateApi } from '../../lib/privateApi';
import { useAuth } from '../../lib/useAuth';
import { AgentImosSection, dialogImoTypes, FormInputs, personalDetailFields, } from '../../components/AgentResources';
import {
  Button,
  FormikValues,
  Label,
  PhoneNumberField,
  SelectField,
  TextField
} from '../../components/formikFormInputs';
import {
  initialValuesPasswordInputs,
  PasswordInputs,
  validationPasswordInputs
} from '../../components/AgentResources/Passwords';
import FormField from '../../components/FindYourStrategy/FormikForms/FormField';
import Loader from '../../components/Loader';
import { SnackbarContext } from '../../components/Snackbar/Context';
import { LOGO_BASE_URL } from '../../server/constants';
import { checkErrorStatusCode, consoleLog, errorLog, handleFormError, noop, pez } from '../../utils/commonUtils';
import { initFalse, prefixAgentNumber } from '../../utils/constants';
import { stateDropDown } from '../../utils/states';
import { SnackBarSeverity } from '../../utils/enums';
import { required, requiredSelectBox } from '../../utils/validation';


function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const ProfileDetailsTab = () => {
  const currentPasswordField = [
    {
      name: 'currentPassword',
      label: <Label label={'Current Password'} required={!initFalse} />,
      type: 'password',
      component: TextField,
      rowSize: 12
    }
  ];
  const formRef = useRef<any>();
  const snackbar = useContext(SnackbarContext);
  const {logout, user} = useAuth();
  const [imageName, setImageName] = React.useState<string>('');
  const [profile, setProfile] = React.useState<any | null>(null);
  const [emailForm, setEmailForm] = React.useState({
    subscribe_marketing: initFalse,
    subscribe_advisors: initFalse
  });
  const [companyLogo, setCompanyLogo] = React.useState({url: ''});
  const [isDeleteCompanyLogo, setIsDeleteCompanyLogo] = React.useState<boolean>(initFalse);
  const updateEmailPreferences = async (e: any) => {
    type EmailForm = typeof emailForm
    type Fields = keyof EmailForm
    const field: Fields = e.target.name

    const newEmailForm = {
      ...emailForm,
      [ field ]: Number(!emailForm[ field ])
    };

    await privateApi.put(`account/unsubscribed-email/${profile.id}`, {
      ...newEmailForm,
      subscribe_all_emails: profile.subscribe_all_emails
    })

    setEmailForm(newEmailForm)
  };
  const submit = async (data: any, {resetForm, setSubmitting}: FormikValues) => {
    setSubmitting(!initFalse);
    try {
      const payload = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phoneNumber: data.mobilePhone,
        agent: {
          companyName: data.companyName,
          officeNumber: data.workPhone,
          companyStreet: data.businessAddress1,
          businessAddress2: data.businessAddress2,
          companyCity: data.city,
          companyState: data.state,
          companyZipCode: data.zipCode,
          designationId: data.designationId,
          designation: data.designationId === 999 ? data.designation : '',
          companyLogo: data.companyLogo,
          agentImos: data.imos
        }
      };

      await privateApi.put(`account/agent`, payload);

      snackbar.showMessage('Agent Profile Updated Successfully.', SnackBarSeverity.Success);
      // @ts-ignore TS1196: Catch clause variable cannot have a type annotation.
    } catch (error: any) {
      errorLog(error);
      snackbar.showMessage(handleFormError(error), SnackBarSeverity.Error);
    } finally {
      setSubmitting(initFalse);
      resetForm();
    }
  };
  const changePassword = async (values: any, {setSubmitting, resetForm}: any) => {
    try {
      await privateApi.put(`/account/password`, values);
      snackbar.showMessage('Password changed successfully.', SnackBarSeverity.Success)
      resetForm()
    } catch (e: any) {
      snackbar.showMessage(handleFormError(e), SnackBarSeverity.Error)
    } finally {
      setSubmitting(initFalse);
    }
  };
  const getProfileAccount = async () => {
    try {
      const response = await privateApi.get('/account/profile');
      const profile = response.data;

      setProfile(profile);
    } catch (err) {
      if (checkErrorStatusCode(err)) {
        logout();
      }
    }
  };
  const [designationList, setDesignationList] = React.useState<{ data: any[] }>({data: []});
  const getDesignationList = async () => {
    const resp = await privateApi.get('common/designation'); // TODO error handling
    setDesignationList(resp.data);
  };
  const updateCompanyLogo = async (_publicUrl: any, fileName: string) => {
    await submit({...formRef.current.values, companyLogo: fileName}, {...formRef.current})
    setCompanyLogo({url: LOGO_BASE_URL + fileName});
  };
  const deleteCompanyLogo = async () => {
    await submit({...formRef.current.values, companyLogo: ''}, {...formRef.current})
    setCompanyLogo({url: ''});
    setIsDeleteCompanyLogo(initFalse);
  };
  const companyFields = [
    {
      name: 'companyName',
      label: <Label label={'Company Name'} required={!initFalse} />,
      component: TextField,
      validate: required,
      rowSize: 6
    },
    {
      name: 'businessAddress1',
      label: <Label label={'Your Business Address 1'} required={!initFalse} />,
      component: TextField,
      validate: required,
      rowSize: 6
    },
    {
      name: 'businessAddress2',
      label: <Label label={'Your Business Address 2'} />,
      component: TextField,
      rowSize: 6
    },
    {
      name: 'city',
      label: <Label label={'City'} required={!initFalse} />,
      component: TextField,
      validate: required,
      rowSize: 6
    },
    {
      name: 'state',
      label: <Label label={'State'} required={!initFalse} />,
      component: SelectField,
      options: stateDropDown.map(x => ({...x, key: x.value})),
      validate: requiredSelectBox,
      rowSize: 6,
      onSelectChange: noop
    },
    {
      name: 'zipCode',
      label: <Label label={'Zip'} required={!initFalse} />,
      component: TextField,
      validate: required,
      rowSize: 6
    },
    {
      id: 'workPhone',
      name: 'workPhone',
      label: <Label label={'Work Phone'} required={!initFalse} />,
      component: PhoneNumberField,
      validate: required,
      rowSize: 6
    },
  ];
  const [isShown, setIsShown] = React.useState(initFalse);

  React.useEffect(() => {
    if (profile && profile.agent && profile.agent.companyLogo) {
      setCompanyLogo({url: LOGO_BASE_URL + profile.agent.companyLogo});
    }
  }, [profile]);

  React.useEffect(() => {
    if (profile) {
      setEmailForm({
        subscribe_marketing: profile.subscribe_marketing,
        subscribe_advisors: profile.subscribe_advisors
      });
      setImageName(profile ? profile.image : '');
    }
  }, [profile])

  React.useEffect(() => {
    getDesignationList().then();
    getProfileAccount().then();
  }, []);

  if (!user) {
    return <Loader />;
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12} lg={8} >
        <Card className="mt45">
          <CardContent>
            {
              profile && (
                <Formik
                  innerRef={formRef} initialValues={{
                  ...profile,
                  mobilePhone: profile.phoneNumber,
                  companyName: profile.agent.companyName,
                  businessAddress1: profile.agent.companyStreet,
                  businessAddress2: profile.agent.businessAddress2,
                  city: profile.agent.companyCity,
                  state: profile.agent.companyState,
                  zipCode: profile.agent.companyZipCode,
                  workPhone: profile.agent.officeNumber,
                  designationId: profile.agent.designationId,
                  designation: profile.agent.designation,
                  imos: (profile.agent.agentImos || []).map((agentImo: any) => {
                    if (!agentImo.imo) {
                      return {};
                    }
                    const imo = agentImo.imo;
                    const state = stateDropDown.find(x => x.value === imo.state)

                    const carrierNumbers = agentImo.agentImoCarriers.map((agentImoCarrier: any) => ({
                      [ prefixAgentNumber + agentImoCarrier.carrier.id ]: agentImoCarrier.code
                    }))
                      // to object
                      .reduce((a: any, v: any) => ({...a, ...v}))

                    return {
                      carriers: agentImo.agentImoCarriers.map((agentImoCarrier: any) => ({
                        ...agentImoCarrier.carrier,
                        code: pez(agentImoCarrier.code)
                      })),
                      contactFirstName: pez(imo.user.firstName),
                      contactLastName: pez(imo.user.lastName),
                      id: imo.id,
                      imoEmail: pez(imo.imoEmail),
                      irr: imo.irr,
                      name: imo.groupName,
                      phone: pez(imo.officeNumber),
                      state: state ? state.value : '',
                      ...carrierNumbers
                    }
                  }),

                }} validationSchema={
                  Yup.object({
                    firstName: Yup.string().required().label('First Name'),
                    lastName: Yup.string().required().label('Last Name'),
                    email: Yup.string().email().label('Email').required(),
                    mobilePhone: Yup.string().required().label('Mobile phone'),
                  })
                } onSubmit={submit}
                >
                  {({
                      isSubmitting,
                      errors,
                      values,
                      touched,
                      handleChange,
                      handleBlur,
                      dirty
                    }: FormikValues) => (
                    <Form>
                      <Typography variant="caption" component="strong" color="primary" className="mb10 floatLeft w100">
                        Personal Details
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={5} md={4} lg={3} xl={4}>
                          <ProfileImage imageName={imageName} setImageName={setImageName} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={8} lg={9} xl={8}>
                          <Grid container spacing={2}>
                            <FormInputs
                              fields={
                                personalDetailFields
                                  .map(fieldProps => (
                                    (fieldProps.name === 'email') ? {...fieldProps, disabled: !initFalse} : fieldProps)
                                  )
                              }
                              {...{errors, values, touched, handleChange, handleBlur}} />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Typography
                        variant="caption" component="strong" color="primary" className="floatLeft w100 mb15 mt30"
                      >
                        Your Company/Agency Information
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6}>
                          <FileUpload
                            dirName={'companyLogo'}
                            width="250"
                            height="70"
                            onFinish={(publicUrl: string, name: string) => updateCompanyLogo(publicUrl, name)}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          onMouseEnter={() => setIsShown(!initFalse)}
                          onMouseLeave={() => setIsShown(initFalse)}
                        >
                          {
                            companyLogo.url &&
                            <>
                              {
                                isShown &&
                                <Tooltip title="Delete" className="floatRight">
                                  <IconButton
                                    key="delete"
                                    aria-label="delete"
                                    color="inherit"
                                    className="pt0 pb0"
                                    onClick={() => setIsDeleteCompanyLogo(!initFalse)}
                                  >
                                    <DeleteRounded className="colorRed" />
                                  </IconButton>
                                </Tooltip>
                              }
                              <img
                                alt="companyLogo" className="floatLeft" src={`${companyLogo.url}?${Date.now()}`}
                              />
                            </>
                          }
                        </Grid>
                        <FormInputs
                          fields={companyFields}
                          {...{errors, values, touched, handleChange, handleBlur}} />
                        <DesignationFields
                          ownDesignation={values.designationId === 999} designationList={designationList}
                          {...{errors, values, touched, handleChange, handleBlur}} />
                      </Grid>

                      {
                        isDeleteCompanyLogo &&
                        <DeleteModal
                          open={!initFalse}
                          content="Are you sure want to delete company logo?"
                          handleClose={() => setIsDeleteCompanyLogo(initFalse)}
                          handleYes={deleteCompanyLogo}
                          accountType="image"
                        />
                      }
                      <AgentImosSection
                        values={values}
                        errors={errors}
                        touched={touched}
                        addLabel={dialogImoTypes.add.title}
                        addDialogImoType={dialogImoTypes.add}
                      />
                      <Button
                        className="mt20 mb20"
                        color="primary"
                        disabled={(isSubmitting || !dirty)}
                        label="Save Profile"
                        type="submit"
                        variant="contained"
                      />
                    </Form>
                  )}
                </Formik>
              )}
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={12} lg={4}>
        <Card className="mt45 floatLeft w100">
          <CardContent>
            <Typography variant="caption" component="strong" className="floatLeft w100">
              Change Your Password
            </Typography>
            <Formik
              initialValues={{
                currentPassword: '',
                ...initialValuesPasswordInputs
              }} onSubmit={changePassword} validationSchema={
              Yup.object({
                  currentPassword: Yup.string().required('Current password is a required field'),
                  ...validationPasswordInputs
                }
              )}
            >
              {({isSubmitting, errors, values, touched, handleChange, handleBlur}) => (
                <Form>
                  <Grid container spacing={2}>
                    <FormInputs
                      fields={currentPasswordField}
                      {...{errors, values, touched, handleChange, handleBlur}} />
                    <PasswordInputs
                      {...{errors, values, touched, handleChange, handleBlur}} />
                  </Grid>

                  <Grid container justifyContent="space-between" alignItems="center" style={{marginTop: '10px'}}>
                    <Button
                      size="medium"
                      className=""
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      Change Password
                    </Button>
                  </Grid>
                </Form>
              )}
            </Formik>
          </CardContent>
        </Card>

        <Card className="mt30 floatLeft w100">
          <CardContent>
            <Typography variant="caption" component="strong" className="floatLeft w100 mb15">
              Email Preferences
            </Typography>

            {
              profile && (
                <FormControl component="fieldset" className="floatLeft w100">
                  <Typography variant="caption" color="primary" className="mb15 floatLeft w100">
                    What type of emails would you like to receive?
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      color="primary" className="mb15 textPrimary" label="Marketing emails, news, and offers." control={(
                      <Checkbox
                        className="cardPadding0 mr10 ml15"
                        color="primary"
                        name="subscribe_marketing"
                        checked={emailForm.subscribe_marketing}
                        onChange={updateEmailPreferences}
                      />
                    )}
                    />
                    <FormControlLabel
                      color="primary"
                      className="mb15 textPrimary"
                      label={`Important notifications from your agent, ${profile.firstName}`}
                      control={(
                        <Checkbox
                          className="cardPadding0 mr10 ml15"
                          color="primary"
                          name="subscribe_advisors"
                          checked={emailForm.subscribe_advisors}
                          onChange={updateEmailPreferences}
                        />
                      )}
                    />
                  </FormGroup>
                </FormControl>
              )
            }
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
};

export const DesignationFields = (props: any) => {
  const {designationList, errors, handleBlur, handleChange, ownDesignation, touched, values} = props;
  const getDesignationDropDown = () => {
    let designationListArr: object[] = [];
    designationList.data && designationList.data.forEach((d: any) => {
      const pushTo = {
        key: d.id,
        value: d.id,
        name: d.name,
      };
      designationListArr.push(pushTo);
    });
    const ownDesignation = {
      key: 999,
      value: 999,
      name: 'Others - Enter my own designation'
    }
    designationListArr.push(ownDesignation);
    return designationListArr;
  };
  const commonProps = {errors, handleBlur, handleChange, touched, values};
  const selProps = {
    component: SelectField,
    defaultValue: '',
    label: <Label label={'Agent Designation'} />,
    name: 'designationId',
    onSelectChange: (val: number) => consoleLog('val', val),
    options: getDesignationDropDown(),
    rowSize: 6,
  };
  const ownDestProps = {
    component: TextField,
    label: 'Designation',
    name: 'designation',
    rowSize: 6,
  };

  return (
    <>
      <FormField {...commonProps} {...selProps} />
      <Grid item xs={12} sm={6} md={6}></Grid>
      {
        ownDesignation &&
        <FormField {...commonProps} {...ownDestProps} />
      }
    </>
  )
}

const Profile = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Layout>
      <Grid container spacing={2}>
        <Banner title="My Profile" description="Manage your profile and view your agent documents." />
        <Grid item xs={12} md={12} lg={12}>
          <AppBar position="static" color="default">
            <Tabs
              value={value} onChange={handleChange} variant="fullWidth" indicatorColor="primary" textColor="primary"
            >
              <Tab label="PROFILE DETAILS" {...a11yProps(0)} />
              <Tab label="MY AGENT DOCUMENTS" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <ProfileDetailsTab />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <AgentProfileDocument />
          </TabPanel>
        </Grid>
      </Grid>
    </Layout>
  )
}

export default Profile;
